export default "__VITE_ASSET__AMuRRU$y__"